import type { IconData } from '@stacksjs/iconify-core'

export const keyboard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 80H40a24.03 24.03 0 0 0-24 24v240a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V104a24.03 24.03 0 0 0-24-24m-8 256H48V112h416Z\"/><path fill=\"currentColor\" d=\"M144 272h160v32H144zm-64 0h32v32H80zm320 0h32v32h-32zm-64 0h32v32h-32zm32-64h32v32h-32zm-64 0h32v32h-32zm-64 0h32v32h-32zm-64 0h32v32h-32zm-64 0h32v32h-32zm224-64h32v32h-32zm64 0h32v32h-32zm-128 0h32v32h-32zm-64 0h32v32h-32zm-64 0h32v32h-32zm-64 0h32v32H80z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default keyboard
